import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Componente para redirigir rutas obsoletas permanentemente
 * @param {string} to - URL destino del redirect
 * @param {boolean} replace - Si true, reemplaza history (default: true para redirects permanentes)
 */
export default function RedirectRoute({ to, replace = true }) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to, { replace });
  }, [navigate, to, replace]);

  // Mientras redirige, mostrar mensaje breve
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirigiendo...</p>
      </div>
    </div>
  );
}
